<ng-container *transloco="let t">
    <app-admin-modal-layout
            [title]="scoringConfiguration?.id
      ? 'league.scoring.individual.config.edit'
      : 'league.scoring.individual.config.add'"
            [saveDisabled]="inputForm.invalid || disableEditing"
            (onSave)="onSaveButtonClick()"
            (onClose)="onClose()"
    >
      <div class="pb-4">
        <form [formGroup]="inputForm">

            <div class="row">
                <div class="col-12 col-xl-6 pb-3">
                    <app-input formControlName="name" label="app.common.name" />
                </div>
                <div class="col-12 col-xl-6 pb-3">
                    <app-select
                            formControlName="scoringDefinition"
                            [items]="scoringDefinitions"
                            [labelKey]="'name'"
                            [valueKey]="'id'"
                            label="league.scoring.definition"
                    />
                </div>
            </div>


            <div class="row">
                <div class="col-12 col-xl-6 pb-3">
                    <app-input
                            type="number"
                            formControlName="minFinishedRacesForScoring"
                            [displayParentError]="inputForm.hasError('minNotLessThanMax')"
                            label="league.scoring.minFinishedRacesForScoring"
                    />
                </div>
                <div class="col-12 col-xl-6 pb-3">
                    <app-input
                            type="number"
                            formControlName="maxFinishedRacesForScoring"
                            [displayParentError]="inputForm.hasError('minNotLessThanMax')"
                            label="league.scoring.maxFinishedRacesForScoring"
                    />
                </div>
            </div>

            @if (inputForm.hasError('minNotLessThanMax')) {
            <div class="mb-1">
             <span class="error">
                {{t('league.scoring.minNotLessThanMax.error')}}
                </span>
            </div>

            }

            <div class="row">
               <div class="col-12 col-xl-6 pb-3">
                    <app-date-time-input formControlName="registrationDeadline" [displayTime]="true"
                                         [label]="t('league.scoring.registrationDeadline')"/>
                </div>
               <div class="col-12 col-xl-6 pb-3">
                   @if ((inputForm.controls.maxFinishedRacesForScoring.value ?? 0) > 0) {
                   <app-select
                     formControlName="attendanceBonusType"
                     [items]="attendanceBonusTypes"
                     labelKeyPrefix="league.scoring.attendanceBonusType."
                     label="league.scoring.attendanceBonusType"
                     [valueKey]="'id'"
                     labelKey="id"
                   />
                   }
                 </div>
               </div>


            @if (inputForm.controls.attendanceBonusType.value === AttendanceBonusType.FIXED_ATTENDANCE_BONUS_POINTS) {
            <div class="col-12 pb-3">
              <app-input
                type="number"
                formControlName="fixedAttendanceBonus"
                label="league.scoring.fixedAttendanceBonus"
              />
            </div>
            }

            @else if (inputForm.controls['attendanceBonusType'].value === AttendanceBonusType.VARIABLE_ATTENDANCE_BONUS_POINTS) {
            <div class="py-3 d-flex justify-content-between align-items-center">
              <div>
                <span class="fw-bold text-uppercase fs-18">
                {{ t('league.scoring.variableAttendanceBonus.title') }}
                </span>
             </div>

          <div>
           @if (!disableEditing) {
            <app-rounded-button
              [label]="t('league.scoring.variableAttendanceBonus.add')"
              (onClick)="addVariableAttendanceBonus()"
              [btnClass]="'rounded-button--solid'"
            >
              <i class="bi bi-plus-circle pe-2"></i>
            </app-rounded-button>
            }
          </div>
        </div>

        <div>
          <div formArrayName="variableAttendanceBonuses">

            @if (inputForm.hasError('invalidRaceStartIndexes')) {
            <p class="pt-2">
                <ngb-alert [dismissible]="false" type="error-info">
                    {{t('league.scoring.variableAttendanceBonus.invalidRaceStartIndexes.error',
                    {value: inputForm.controls.maxFinishedRacesForScoring.value})}}
                </ngb-alert>
            </p>
            }
            @if (inputForm.hasError('duplicateRaceIndexes')) {
            <p class="pt-2">
                <ngb-alert [dismissible]="false" type="error-info">
                    {{t('league.scoring.variableAttendanceBonus.duplicateRaceIndexes.error')}}
                </ngb-alert>
            </p>
            }
            <div class="bonus-holder">
            @for (variableBonus of variableAttendanceBonuses.controls; track variableBonus; let vbi = $index; let last = $last) {
            <div [formGroupName]="vbi" class="mt-3">
                <div class="row pt-2">

                    <div class="col-5">
                        <app-input
                                formControlName="raceNumber"
                                label="league.scoring.variableAttendanceBonus.raceNumber"
                                formId="raceNumber{{vbi}}"
                                type="number"
                                [displayParentError]="
                        (inputForm.errors?.['duplicateRaceIndexes']?.includes(vbi) ||
                        inputForm.errors?.['invalidRaceStartIndexes']?.includes(vbi)) || false
                      "
                        />
                    </div>

                    <div class="col-5">
                        <app-input
                                formControlName="bonusPoints"
                                label="league.scoring.variableAttendanceBonus.bonusPoints"
                                formId="bonusPoint{{vbi}}"
                                type="number"
                        />
                    </div>

                    <div class="col-2 d-flex align-items-center justify-content-center pt-3">
                        @if (!disableEditing) {
                        <app-floating-icon-button
                                iconClass="fas fa-trash-alt"
                                (onClick)="deleteVariableAttendanceBonus(vbi)"
                        />
                        }
                    </div>

                </div>
            </div>
            }
            </div>

            </div>
          </div>

            }

        </form>
      </div>
    </app-admin-modal-layout>
</ng-container>
